<template>
  <van-checkbox
    v-model="checkValue"
    :disabled="disabled"
    @click="click"
    :label="label"
    :name="name"
    class="checkbox"
  >
    <template #icon="props">
      <img
        v-if="!disabled"
        class="img-icon"
        :src="!props.checked ? activeIcon : inactiveIcon"
      />
      <img
        v-else
        class="img-icon"
        :src="!props.checked ? disabledIcon : indisabledIcon"
      />
    </template>
    <slot></slot>
  </van-checkbox>
</template>

<script>
import activeIcon from '@/assets/img/projectAppoint/checkbox.png'
import inactiveIcon from '@/assets/img/projectAppoint/checkbox_select.png'
import disabledIcon from '@/assets/img/projectAppoint/checkbox_disabled.png'
import indisabledIcon from '@/assets/img/projectAppoint/checkbox_select_disabled.png'
export default {
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      activeIcon: activeIcon,
      inactiveIcon: inactiveIcon,
      disabledIcon: disabledIcon,
      indisabledIcon: indisabledIcon,
      checkValue: this.value
    }
  },
  watch: {
    checkValue(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.checkValue = val
    }
  },
  computed: {},
  methods: {
    click() {
      this.$emit('click')
    }
  },
  created() {},
  mounted() {}
}
</script>
<style lang="scss" scoped>
.checkbox {
  font-size: 14px;
  font-weight: 500;
  color: #333333;
}
.img-icon {
  width: 14px;
  height: 14px;
}
</style>
